<mat-accordion class="custom-mat-accordion" [multi]="true">
  <mat-expansion-panel class="custom-mat-expansion-panel other-info-form" *ngFor="let formKey of formKeyList; let formIndex = index" [expanded]="openedPanel.includes(formIndex)" (opened)="openPanel(formIndex)" (closed)="closePanel(formIndex)" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{otherDataMetadata[formKey]?.formTitle ? otherDataMetadata[formKey]?.formTitle : formKey}}
      </mat-panel-title>
      <img class="themified-white-icon other-info-form__title-icon"
           [src]="openedPanel.includes(formIndex) ? '/assets/icons/minus-icon-white.png' : '/assets/icons/plus-icon-white.png'"/>
    </mat-expansion-panel-header>

    <ng-container *ngIf="!editMode">
      <div class="particular" *ngFor="let question of formQuestionKeyList[formKey]; let questionIndex = index">
        <div *ngIf="question.slice(0, 4) !== formQuestionKeyList[formKey][questionIndex-1]?.slice(0, 4)" class="other-info-form__section-title">
          {{otherDataMetadata[formKey]?.formPages[question.slice(0, 4)]}} 
        </div>
        <div class="particular__label">{{ parseQuestionFormat(question) }}</div>
        <ng-container *ngIf="showAnswerAsString(otherData[formKey][question]); else objectAnswer">
          <div class="particular__value">{{ parseStringAnswerFormat(otherData[formKey][question]) }}</div>
        </ng-container>
        <ng-template #objectAnswer>
          <ng-container *ngIf="isArray(otherData[formKey][question])">
            <div class="particular__multi-value-answer-container" *ngFor="let answerItem of otherData[formKey][question]; let answerItemIndex = index">
              <div class="particular__multi-value-answer-index">#{{answerItemIndex+1}}</div>
              <div class="particular__multi-value-answer-content">
                <div class="particular__multi-value-answer-item" *ngFor="let answerItemContent of answerItem | keyvalue">
                  <div class="particular__label">{{ answerItemContent.key }}</div>
                  <div class="particular__value">{{ answerItemContent.value }}</div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isArray(otherData[formKey][question])">
            <div class="particular__multi-value-answer-item" *ngFor="let answerItemContent of otherData[formKey][question] | keyvalue ; let answerItemIndex = index">
              <div class="particular__multi-value-answer-container">
                <div class="particular__multi-value-answer-index">#{{answerItemIndex+1}}</div>
                <div class="particular__multi-value-answer-content">
                  <div class="particular__label">{{ answerItemContent.key }}</div>
                  <div class="particular__value">{{ answerItemContent.value }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="editMode">
      <div class="particular particular_edit-mode" *ngFor="let question of formQuestionKeyList[formKey]; let questionIndex = index">
        <div *ngIf="question.slice(0, 4) !== formQuestionKeyList[formKey][questionIndex-1]?.slice(0, 4)" class="other-info-form__section-title">
          {{otherDataMetadata[formKey]?.formPages[question.slice(0, 4)]}}
        </div>
        <div class="particular__label">{{ parseQuestionFormat(question) }}</div>
        <ng-container *ngIf="!(otherData[formKey][question] | isObject) else objectAnswer">
          <mat-form-field class="custom-mat-form-field particular__input-field" floatLabel="never">
            <input matInput [(ngModel)]="otherData[formKey][question]" autocomplete="off">
          </mat-form-field>
        </ng-container>
        <ng-template #objectAnswer>
          <ng-container *ngIf="otherData[formKey][question] | isArray">
            <div class="particular__multi-value-answer-container" *ngFor="let answerItem of otherData[formKey][question]; let answerItemIndex = index">
              <div class="particular__multi-value-answer-index">#{{answerItemIndex+1}}</div>
              <div class="particular__multi-value-answer-content">
                <div class="particular__multi-value-answer-item" *ngFor="let answerItemKey of getObjectAnswerKeyList(answerItem)">
                  <div class="particular__label">{{ answerItemKey }}</div>
                  <mat-form-field class="custom-mat-form-field particular__input-field">
                    <input matInput [(ngModel)]="otherData[formKey][question][answerItemIndex][answerItemKey]" autocomplete="off">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!(otherData[formKey][question] | isArray)">
            <div class="particular__multi-value-answer-item" *ngFor="let answerItemContent of otherData[formKey][question] | keyvalue ; let answerItemIndex = index; trackBy: trackByFn">
              <div class="particular__multi-value-answer-container">
                <div class="particular__multi-value-answer-index">#{{answerItemIndex+1}}</div>
                <div class="particular__multi-value-answer-content">
                  <div class="particular__label">{{ answerItemContent.key }}</div>
                  <mat-form-field class="custom-mat-form-field particular__input-field">
                    <input matInput [(ngModel)]="otherData[formKey][question][answerItemContent.key]" autocomplete="off">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </ng-container>

    <mat-action-row *ngIf="editMode">
      <button mat-button ubi-round-button class="btn btn_rounded other-info-form__btn" (click)="submit(formKey)">
        SAVE
      </button>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
